export default {
  email: 'メールアドレス',
  password: 'パスコード',
  password_confirmation: 'パスワードを確認します',
  phone_nums: '携帯電話番号',
  phone_number: '携帯電話番号',
  first_name: '名',
  last_name: '姓',
  user_id: 'MASTER ID',
  csv_file: 'CSVファイル',
  gift_code_file: 'ギフトコードファイル',
  limit_usage_amount: '利用上限回数',
  expiry_at: '終了日時',
  effective_at: '開始日時',
  charge_amount: 'チャージ金額/1コード',
  card_types: '利用可能商品',
  notification_content: 'お知らせ内容',
  notification_title: 'タイトル',
  push_at: 'push通知予定日',
  against_policy: '反社チェック',
  crime_history: '犯罪履歴チェック',
  address_check: '住所チェック',
  comment: 'コメント',
  kyc_status: 'KYC確認',
  started_at: '表示予定日',
  end_at: '表示終了日',
  tranMonth: '対象年月',
  type: '対象',
  version: 'バージョン',
  link_store: 'リンクストア',
  title: 'タイトル',
  content: 'お知らせ内容',
};
